export const dummyConsultantId = "6ae0233b-d563-432b-a69b-395ae5eefd85";
export const dummyAdvisoryCaseId = "01991a84-1593-7d9b-bf36-201f2dd6a181";
export const dummyAdvisoryCaseId2 = "74c9878e-37e0-4c44-bc0a-8d06752173cb";
